import { createModel } from "@rematch/core";
import type { RootModel } from ".";
import { Group } from "../types/groups.types";

export interface GroupStoreProps {
    items: Group[];
    loading: {
        fetchAll: boolean;
        updateGroup: boolean;
        createGroup: boolean;
        deleteGroup: boolean;
    };
    selectedGroup: Group | null;
}

export const groupInitialState: GroupStoreProps = {
    items: [],
    loading: {
        fetchAll: false,
        updateGroup: false,
        createGroup: false,
        deleteGroup: false,

    },
    selectedGroup: null,
};

export const groups = createModel<RootModel>()({
    state: groupInitialState,
    reducers: {
        toggleLoading: (store, prop: keyof GroupStoreProps["loading"], v: boolean) => ({
            ...store,
            loading: {
                ...store.loading,
                [prop]: v,
            },
        }),
        setGroups: (store, items: Group[]) => ({
            ...store,
            items,
        }),
        createGroupInStore: (store, newGroup: Group) => ({
            ...store,
            items: [...store.items, newGroup],
        }),
        updateGroupInStore: (store, updatedGroup: Group) => ({
            ...store,
            items: store.items.map(group =>
                group.id === updatedGroup.id ? updatedGroup : group
            ),
        }),
        setSelectedGroup: (store, group: Group | null) => ({
            ...store,
            selectedGroup: group,
        }),
    },
});
